const { darken, lighten } = require("polished");

// Used so hover colors get automatically updated
const brandPrimaryColor = "#0A2240"; // navy
const brandSecondaryColor = "#60a60e"; // green
const brandTertiaryColor = "#b0b5c0"; // grey
const brandQuaternaryColor = "#0061a7"; // light blue
const brandBlackColor = "#444444"; // black
const brandGreyColor = "#e7e9ec"; // grey
const brandWhiteColor = "#FFFFFF";

const colors = {
    // Brand & Accent
    "brand-primary": brandPrimaryColor,
    "brand-secondary": brandSecondaryColor,
    "brand-tertiary": brandTertiaryColor,
    "brand-quaternary": brandQuaternaryColor,

    // Base
    "brand-black": brandBlackColor,
    "brand-dark-grey": "#505050",
    "brand-grey": brandGreyColor,
    "brand-light-grey": "#f3f4f6",
    "brand-white": brandWhiteColor,

    // Messages
    "brand-success": "#128a0c",
    "brand-warning": "#e67500",
    "brand-danger": "#ee0000",
    "brand-info": "#0064ff",

    // Alerts
    "brand-success-alert": "#E9F7E5",
    "brand-warning-alert": "#FEF5E6",
    "brand-danger-alert": "#FCE5E7",
    "brand-info-alert": "#E5F4FC",

    // Alert Borders
    "brand-success-alert-border": "#D5F0CE",
    "brand-warning-alert-border": "#FDECD0",
    "brand-danger-alert-border": "#F9CED2",
    "brand-info-alert-border": "#CEEAF9",

    // Checkbox Count
    "brand-checkbox-count": "#909090",

    // Lighten & Darken
    "brand-primary-lighten": "#2f435d",
    "brand-primary-darken": darken(0.05, brandPrimaryColor),

    "brand-secondary-lighten": lighten(0.05, brandSecondaryColor),
    "brand-secondary-darken": darken(0.05, brandSecondaryColor),

    "brand-tertiary-lighten": lighten(0.05, brandTertiaryColor),
    "brand-tertiary-darken": darken(0.05, brandTertiaryColor),

    "brand-quaternary-lighten": lighten(0.05, brandQuaternaryColor),
    "brand-quaternary-darken": darken(0.05, brandQuaternaryColor),

    "brand-black-lighten": lighten(0.05, brandBlackColor),
    "brand-black-darken": darken(0.05, brandBlackColor),

    "brand-grey-lighten": lighten(0.05, brandGreyColor),
    "brand-grey-darken": darken(0.05, brandGreyColor),

    "brand-white-lighten": lighten(0.05, brandWhiteColor),
    "brand-white-darken": darken(0.05, brandWhiteColor),
};

const fonts = {
    heading: ["proxima-nova, sans-serif"],
    body: ["proxima-nova, sans-serif"],
};

module.exports = { colors, fonts };
